import React from "react";
import useMasjidFormat from "../../../hooks/useMasjidFormat";

const PRAYERS = ["Fajr", "Sunrise", "Dhuhr", "Asr", "Maghrib", "Isha"];

// "05:00 (GMT)" -> "05:00"
export const hhmm = (v) => {
  const m = String(v || "").match(/(\d{1,2}):(\d{2})/);
  return m ? `${m[1].padStart(2, "0")}:${m[2]}` : "";
};

// A day's time for a prayer: a plain time, or { startTime, iqamahTime }.
export const athanOf = (day, p) => hhmm(day?.timings?.[p]?.startTime || day?.timings?.[p]);
export const iqamahOf = (day, p) => hhmm(day?.timings?.[p]?.iqamahTime);

const todayDashed = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
};

// showIqamah: each prayer shows its Athan and, under it, its Iqamah.
const PrayerTimeTable = ({ prayerTimes, showIqamah = false }) => {
  const today = todayDashed();
  const f = useMasjidFormat();
  return (
    <div className="max-w-full mx-auto">
      <div className="mt-6 shadow-sm border border-gray-300 rounded-lg overflow-x-auto">
        <table className="w-full table-auto text-sm text-left">
          <thead className="bg-gray-100 text-gray-600 font-medium border-b border-gray-300">
            <tr>
              {/* The date stays in view while the times scroll sideways. */}
              <th className="sticky left-0 z-10 bg-gray-100 py-3 px-4 shadow-[1px_0_0_#e5e7eb]">Date</th>
              {PRAYERS.map((p) => (
                <th key={p} className="py-3 px-4">
                  {p}
                  {showIqamah && p !== "Sunrise" && <span className="block text-xs font-normal text-gray-500">Athan / Iqamah</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-700 divide-y">
            {prayerTimes?.map((day, idx) => {
              const date = day?.date?.gregorian?.date || day?.date?.gregorian?.data;
              const isToday = date === today;
              return (
                <tr key={date || idx} className={isToday ? "bg-blue-50" : ""} aria-current={isToday ? "date" : undefined}>
                  <td className={`sticky left-0 z-10 shadow-[1px_0_0_#e5e7eb] ${isToday ? "bg-blue-50" : "bg-white"} py-3 px-4 whitespace-nowrap`}>
                    <span className="block text-gray-800 text-sm font-medium">
                      {day?.date?.gregorian?.weekday?.en} {f.date(date)}
                      {isToday && <span className="ml-2 rounded bg-blue-600 px-1.5 py-0.5 text-[10px] font-semibold text-white">Today</span>}
                    </span>
                    {day?.date?.hijri && (
                      <span className="block text-gray-500 text-xs">
                        {day.date.hijri.day} {day.date.hijri.month?.en} {day.date.hijri.year}
                      </span>
                    )}
                  </td>
                  {PRAYERS.map((p) => (
                    <td key={p} className="px-4 py-3 font-medium text-gray-700 whitespace-nowrap tabular-nums">
                      {f.time(athanOf(day, p))}
                      {showIqamah && p !== "Sunrise" && (
                        <span className="text-gray-400"> / <span className="text-emerald-700">{f.time(iqamahOf(day, p))}</span></span>
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrayerTimeTable;
